import { create } from "zustand";
import { UnitStatusFilters } from "@safelease/service-utilities";

type UnitListStore = {
  selectedLocationId: string | null;
  setSelectedLocationId: (selectedLocationId: string | null) => void;
  selectedRelationshipId: string | null;
  setSelectedRelationshipId: (selectedRelationshipId: string | null) => void;
  selectedTab: UnitStatusFilters;
  setSelectedTab: (selectedTab: UnitStatusFilters) => void;
  searchTerm: string;
  setSearchTerm: (searchTerm: string) => void;
};

export const useUnitListStore = create<UnitListStore>()((set) => ({
  selectedLocationId: null,
  setSelectedLocationId: (selectedLocationId) => {
    set({
      selectedLocationId,
    });
  },
  selectedRelationshipId: null,
  setSelectedRelationshipId: (selectedRelationshipId) => {
    set({
      selectedRelationshipId,
    });
  },
  selectedTab: UnitStatusFilters.ALL,
  setSelectedTab: (selectedTab) => {
    set({
      selectedTab,
    });
  },
  searchTerm: "",
  setSearchTerm: (searchTerm) => {
    set({
      searchTerm,
    });
  },
}));
